import Navbar from "./scenes/Navbar";
import Landing from "./scenes/Landing";
import DotGroup from "./scenes/DotGroup";
import LinearGradient from "./components/LinearGradient"
// import MySkills from "./scenes/MySkills";
// import LineGradient from "./components/LineGradient";
import Projects from "./scenes/Projects";
import Contact from "./scenes/Contact";
import Footer from "./scenes/Footer";
import useMediaQuery from "./hooks/useMediaQuery";
import { useEffect, useState } from "react";
import Testimonials from "./scenes/Testimonials";
import { motion } from "framer-motion";
import MySkills from "./scenes/MySkills"

function App() {
  const [selectedPage, setSelectedPage] = useState("home");
  const [isTopOfPage, setIsTopOfPage] = useState(true);
  const isDesktop = useMediaQuery("(min-width: 1060px)");

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setIsTopOfPage(true);
        setSelectedPage("home");
      }
      if (window.scrollY !== 0) setIsTopOfPage(false);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="app bg-deep-blue">
      <Navbar
        isTopOfPage={isTopOfPage}
        selectedPage={selectedPage}
        setSelectedPage={setSelectedPage}
      />
      <div className="w-5/6 mx-auto md:h-full">
        {isDesktop && (
          <DotGroup
            selectedPage={selectedPage}
            setSelectedPage={setSelectedPage}
          />
        )}
          <Landing setSelectedPage={setSelectedPage} />
      </div>
      <LinearGradient/>
      <div className="w-5/3 mx-auto md:h-full">
        <MySkills/>

      </div>
      <LinearGradient/>
      <div className="w-5/6 mx-auto">
        <Projects/>

      </div>
      <LinearGradient/>
      <div className="w-5/6 mx-auto">
        <Testimonials/>
        
      </div>
      <LinearGradient/>
      <div className="w-5/6 mx-auto">
        <Contact/>
        
      </div>
      <Footer/>
      
    </div>
  );
}

export default App;
